import { GenericMessageTypes } from '@Pages/genericMessagePage/queryParamsSchema';
import { router } from '@Routes/index';
import { EnvironmentVariables, getEnvironmentVariable } from '@Services/env/environment.service.ts';
import { useBoundStore } from '@Store/index.ts';
import { routesModel } from './router.consts';
import { RoutesMap } from './router.types';
import { _getPageIndex, _handleUnAuthorized } from './routesUtil/RoutesUtil';
import { updateNavStack } from './useSendNavStack';

export const isCustomerAuth = (): boolean => {
  const { accessToken } = useBoundStore.getState().customer;
  const isOnboardingAuthenticated = useBoundStore.getState().isOnboardingAuthenticated;
  return !!accessToken || isOnboardingAuthenticated;
};
export interface IBeforeLoadGeneral {
  page: RoutesMap;
  shouldUpdateServerNavStack: boolean;
  force?: boolean;
  shouldAvoidAuthCheck?: boolean;
  stepToReturn?: RoutesMap;
}

export const beforeLoadGeneral = ({
  page,
  shouldUpdateServerNavStack,
  force,
  shouldAvoidAuthCheck,
  stepToReturn,
}: IBeforeLoadGeneral): void => {
  const setCurrentPageIndex = useBoundStore.getState().onboardingSlice.setCurrentPageIndex;
  const shouldAvoidAuthCheckEnv = getEnvironmentVariable(
    EnvironmentVariables.VITE_SHOULD_AVOID_ROUTE_AUTH_CHECK
  );

  if (!isCustomerAuth() && !shouldAvoidAuthCheck && !shouldAvoidAuthCheckEnv) {
    _handleUnAuthorized();
    return;
  }

  if (useBoundStore.getState().onboardingSlice.isOnboardingLocked) {
    router.navigate({
      to: routesModel[RoutesMap.GENERIC_MESSAGE_PAGE].path,
      search: { type: GenericMessageTypes.USER_LOCKED },
    });
    return;
  }

  if (!setCurrentPageIndex) return;

  const isEditMode = useBoundStore.getState().onboardingSlice.editMode;
  const newPageIndex = _getPageIndex(page);
  const isNavigatingBackward =
    newPageIndex < useBoundStore.getState().onboardingSlice.currentPageIndex;

  if (shouldUpdateServerNavStack && !isEditMode && !isNavigatingBackward) {
    updateNavStack({ currentPage: page, force, stepToReturn: stepToReturn }).catch(() => {});
  }
  setCurrentPageIndex(newPageIndex);
};
